// Native details works without JavaScript. Enhance navigation and Escape focus.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.nyttu-menu a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.nyttu-menu[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
